import { Loadable, LoadableStatus } from '@aiwyn/shared';
import { PaymentPlanUi, TaxPaymentResponse } from '@aiwyn/api';
import {
  EngagementScheduledPaymentModel,
  HasuraScheduledPaymentModel,
  ScheduledPaymentUiModel,
} from '../../../../api/models/scheduled-payment.models';

export interface SettingsStateModel {
  // AutoPay vars
  processingAutoPayDisable: LoadableStatus;

  paymentPlans: Loadable<PaymentPlanUi[]>;
  v3Payments: Loadable<ScheduledPaymentUiModel[]>;
  v4Payments: Loadable<HasuraScheduledPaymentModel[]>;
  v4EngagementPayments: Loadable<EngagementScheduledPaymentModel[]>;
  taxPayments: Loadable<TaxPaymentResponse[]>;
}

export const DEFAULT_SETTINGS_STATE_MODEL: SettingsStateModel = {
  processingAutoPayDisable: LoadableStatus.DEFAULT,

  paymentPlans: { status: LoadableStatus.DEFAULT, data: [] },
  v3Payments: { status: LoadableStatus.DEFAULT, data: [] },
  v4Payments: { status: LoadableStatus.DEFAULT, data: [] },
  v4EngagementPayments: { status: LoadableStatus.DEFAULT, data: [] },
  taxPayments: { status: LoadableStatus.DEFAULT, data: [] },
};
